export default __webpack_public_path__ + "static/media/share.96d10bf2.svg";